import React, { useState } from 'react';
import './NationalSection.css';
import background from '../../assets/images/national-section-bg.jpg';
import videoThumbnail from '../../assets/images/video-thumbnail.png';
import najdVideo from '../../assets/videos/Najd Video.mp4'; // ✅ Import local video

const NationalSection = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <section
      className="national-section"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="video-container">
        {!showVideo ? (
          <div className="video-frame" onClick={() => setShowVideo(true)}>
            <div className="hover-thumbnail">
              <img src={videoThumbnail} alt="Video Preview" />
              <div className="play-button">&#9658;</div>
            </div>
          </div>
        ) : (
          <video
            className="video-embed"
            src={najdVideo}
            controls
            autoPlay
          />
        )}
      </div>
    </section>
  );
};

export default NationalSection;
